const calculator = {
  determineCommissionLevel(productLevels, sellPrice) { // return -1 if less than minimum
    let res = -1;
    const productLevelsMapped = productLevels.map((elm, i) => ({ level: i + 1, ...elm }));
    productLevelsMapped.reverse().forEach((level) => {
      if (res !== -1) return;
      if (sellPrice >= level.sellPriceMin) res = level.level;
    });
    return res;
  },
  productCommission(productLevels, sellPrice, amount) {
    const levelNum = calculator.determineCommissionLevel(productLevels, sellPrice) - 1;
    if (levelNum <= -1) return 0;
    const level = productLevels[levelNum];
    let comm = -1;
    if (level.commission.isPercent) {
      comm = sellPrice * amount * level.commission.amount;
    } else {
      comm = amount * level.commission.amount;
    }
    return comm;
  },
};

export default calculator;
